import { MenuItem } from '../models/menu-item.model';

export const menuFooter: MenuItem[] = [
    {
        url: '/products',
        name: 'NAVIGATION.MAIN.products',
        activeClass: 'active',
    },
    {
        url: '/about-us',
        name: 'NAVIGATION.MAIN.about_us',
        activeClass: 'active',
    },
    {
        url: '/our-showroom',
        name: 'NAVIGATION.MAIN.our_showroom',
        activeClass: 'active',
    },
    {
        url: '/configurator',
        name: 'NAVIGATION.MAIN.configurator',
        activeClass: 'active',
    },
    {
        url: '/certificates',
        name: 'NAVIGATION.MAIN.certificates',
        activeClass: 'active',
    },
    {
        url: '/complaints',
        name: 'NAVIGATION.MAIN.complaints',
        activeClass: 'active',
    },
];
